import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BrandingComponent } from '@ukam/shell/layouts/full/vertical/sidebar/branding.component';
import { MaterialModule } from '@ukam/ui-kit/material.module';

@Component({
  selector: 'app-sidebar',
  imports: [BrandingComponent, MaterialModule],
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  constructor() { }
  @Input() showToggle = true;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  ngOnInit(): void { }
}
